export const fontFamily = ['"SageUI"', '"Helvetica Neue"', 'Helvetica', 'Arial', 'sans-serif'].join(',')
